// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__8ywZf","tab":"ProcedureTabs_tab__1QG6l"};